import React, { Component } from "react";
import { Card, ListGroup, Container, Row, Col } from "react-bootstrap";
import { BASE_URL } from "./utility";

class Contact extends Component {
  render() {
    return (
      <div
        style={{
          backgroundImage: `url(${BASE_URL + "download/general/bg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingBottom: "3rem",
        }}
      >
        <Container style={{ marginTop: "2rem" }}>
          {/* Contact Information */}
          <Card
            className="mb-4 shadow-sm"
            style={{ borderRadius: "15px", backgroundColor: "rgba(255,255,255,0.95)" }}
          >
            <Card.Body>
              <Card.Title style={{ color: "#007bff" }}>Contact Information</Card.Title>
              <hr />
              <Row>
                {/* Phone */}
                <Col md={6} className="mb-3">
                  <Card className="h-100">
                    <Card.Body>
                      <Card.Subtitle className="mb-2 text-muted">Phone</Card.Subtitle>
                      <ListGroup variant="flush">
                        <ListGroup.Item>+91-9818428983</ListGroup.Item>
                        <ListGroup.Item>+91-8851380981</ListGroup.Item>
                        <ListGroup.Item>+91-8178619592</ListGroup.Item>
                      </ListGroup>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Email */}
                <Col md={6} className="mb-3">
                  <Card className="h-100">
                    <Card.Body>
                      <Card.Subtitle className="mb-2 text-muted">Email</Card.Subtitle>
                      <ListGroup variant="flush">
                        <ListGroup.Item>rainbowtouchindia@gmail.com</ListGroup.Item>
                        <ListGroup.Item>sidhantrout23@gmail.com</ListGroup.Item>
                      </ListGroup>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Addresses */}
          <Card
            className="mb-4 shadow-sm"
            style={{ borderRadius: "15px", backgroundColor: "rgba(255,255,255,0.95)" }}
          >
            <Card.Body>
              <Card.Title style={{ color: "#007bff" }}>Our Locations & Addresses</Card.Title>
              <hr />
              <Row>
                <Col md={6} className="mb-3">
                  <Card className="h-100">
                    <Card.Body>
                      <Card.Subtitle className="mb-2 text-muted">Delhi</Card.Subtitle>
                      <p>F-711, Lado Sarai, Golf Course Road, Near Mehrauli, Delhi - 110074</p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6} className="mb-3">
                  <Card className="h-100">
                    <Card.Body>
                      <Card.Subtitle className="mb-2 text-muted">Bhubaneswar</Card.Subtitle>
                      <p>Plot No-2146/11968, Lane-2, Railway Colony, Bhotapada, Mancheswar, Bhubaneswar, Odisha - 751017</p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Google Maps */}
          <Card
            className="mb-4 shadow-sm"
            style={{ borderRadius: "15px", backgroundColor: "rgba(255,255,255,0.95)" }}
          >
            <Card.Body>
              <Card.Title style={{ color: "#007bff" }}>Our Locations on Map</Card.Title>
              <hr />
              <Row>
                {/* Delhi Map */}
                <Col md={6} className="mb-3">
                  <Card>
                    <Card.Body>
                      <Card.Subtitle className="mb-3 text-muted">Delhi</Card.Subtitle>
                      <div style={{ borderRadius: "10px", overflow: "hidden" }}>
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3505.406871120986!2d77.19212631440463!3d28.52748779557965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1fef9072db3d%3A0xe831674cdc799f2e!2sRainbow%20Touch!5e0!3m2!1sen!2sin!4v1608536549039!5m2!1sen!2sin"
                          width="100%"
                          height="300"
                          style={{ border: 0 }}
                          allowFullScreen=""
                          loading="lazy"
                          title="Delhi Location"
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Bhubaneswar Map */}
                <Col md={6} className="mb-3">
                  <Card>
                    <Card.Body>
                      <Card.Subtitle className="mb-3 text-muted">Bhubaneswar</Card.Subtitle>
                      <div style={{ borderRadius: "10px", overflow: "hidden" }}>
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d935.3348710032327!2d85.84735442291706!3d20.327589520806878!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a1909807240fd9b%3A0xa3fe931df97f31e3!2sMancheswar%2C%20Bhubaneswar%2C%20Odisha%20751017!5e0!3m2!1sen!2sin!4v1750521477457!5m2!1sen!2sin"
                          width="100%"
                          height="300"
                          style={{ border: 0 }}
                          allowFullScreen=""
                          loading="lazy"
                          title="Bhubaneswar Location"
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </div>
    );
  }
}

export default Contact;
